import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectcompanyUsersInStore,
  selectcompanyUsersPageLoading,
  selectcompanyUsersShowInitWaitingMessage,
} from '../_selectors/companyUser.selectors';

export class CompanyUsersDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectcompanyUsersPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectcompanyUsersShowInitWaitingMessage));

    this.store.pipe(select(selectcompanyUsersInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
